import { a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
import { useRef, useState, useEffect } from 'react';

// This hook gets the component width.

function useComponentWidth() {
  var ref = useRef(null);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    componentWidth = _useState2[0],
    setComponentWidth = _useState2[1];
  var getComponentWidth = function getComponentWidth() {
    if (ref.current) {
      setComponentWidth(ref.current.clientWidth);
    }
  };
  useEffect(function () {
    if (ref.current) {
      setComponentWidth(ref.current.clientWidth);
    }
    window.addEventListener('resize', getComponentWidth, true);
    return function () {
      window.removeEventListener('resize', getComponentWidth, true);
    };
  }, []);

  // For its use, these keys must be imported into the component.

  return [ref, componentWidth];
}

export { useComponentWidth as u };
//# sourceMappingURL=useComponentWidth-dbdc6efa.js.map
